import { render, staticRenderFns } from "./MagicLogin.vue?vue&type=template&id=c3cd5bf4&"
import script from "./MagicLogin.vue?vue&type=script&lang=js&"
export * from "./MagicLogin.vue?vue&type=script&lang=js&"
import style0 from "./MagicLogin.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports